import { Box, VStack, Text, Button, theme } from '@bpba/ui-components';
import { Separador, IconLinea, IconArrow, SolapaMovil } from '../styles/AdhesionClientesStyles';
import CDNI_Comercios_Form from '../../assets/micrositios/CDNI_Comercios_Form.png';
import { useState } from 'react';
import { PopupInicio } from './popup/PopupInicio';
import Simbolito from '../../assets/micrositios/bullet.svg';
import contacto from "../pages/popup/contacto.svg";
import { VideoCDNIComercios } from '../../components/VideoCDNIComercios';
import { Urls } from '../../utils/Url';

export const AdhesionLink = () => {
  const [ver, setVer] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [click, setClick] = useState(false);

  const cardsData = [
    {
      title: <>Abrís tu cuenta 100% digital.</>,
      text1: <>No importa si no sos cliente, hacés todo desde la app.</>,
      text2: <>Lo hacés cuando y donde vos quieras.</>,
      key: 1
    },
    {
      title: <>Cobrás con la comisión más baja: 0,6% final.</>,
      text1: <div style={{ color: '#279c2e' }}>Los tres primeros meses son <a style={{ textDecoration: "underline" }}>sin costo*.</a> </div>,
      text2: <>Sin gastos de mantenimiento, cobrás con el celular</>,
      key: 2
    },
    {
      title: <>Disponés de tu dinero en el momento.</>,
      text1: <>Usás tu plata cuando vos quieras, sin costo extra.</>,
      text2: <>Recibís pagos de todas las billeteras.</>,
      key: 3
    },
    {
      title: <>Cobrás con QR o link de pago.</>,
      text1: <>Participás de nuestras promociones para clientes/as.</>,
      text2: <Text margin={0}>Sumás <a href='https://mesumo.bancoprovincia.com.ar' target='_blank' style={{ textDecoration: "underline", color: '#279c2e' }}>puntos Mesumo </a>con cada venta.</Text>,
      key: 4
    },
  ]


  return (

    <>
      <PopupInicio />

      <Box>
        <VStack width={'100%'} flexDirection={['column', 'column', 'row', 'row']}>
          <Box display={'flex'} flexDirection={'column'} width={['100%', '100%', '70%', '70%']} paddingRight={'5%'}>
            <Box width={'100%'} display={'flex'} justifyContent={['center', 'center', 'flex-start', 'flex-start']}>
              <Box width={['180px', '180px', '388px', '388px']} height={['60px', '60px', '127px', '127px']} marginTop={'1rem'}>
                <img src={CDNI_Comercios_Form} alt="cdni comercios logo" />
              </Box>
            </Box>
            <Text
              fontSize={['26px', '26px', '36px', '36px']}
              color={theme.colors.primary[0]}
              lineHeight={['33px', '33px', '43px', '43px']}
              textAlign={['center', 'center', 'start', 'start']}
              tabIndex={0}
            >
              Cobrá con QR o link de pago desde tu celular sin costo, durante los primeros 3 meses*
            </Text>
            <Text fontSize={'22px'} color={theme.colors.secondary[1]} lineHeight={'27px'} textAlign={['center', 'center', 'start', 'start']} tabIndex={0}>
              Si sos monotributista o responsable inscripto, descargá la app y empezá a cobrar.
            </Text>
          </Box>
          <Box width={['100%', '100%', '30%', '30%']} display={'flex'} justifyContent={'center'} alignItems={"center"} marginBottom={["2rem", "2rem", 0, 0]}>
            <img style={{ width: '180px', height: '330px' }} src={'/CDN/Get/Celu_AppComercios'} alt={"Celular comercio cuenta dni"} />
          </Box>
        </VStack>
      </Box>
      <Box style={{ position: "fixed", bottom: "10px", textDecoration: "none", width: "100%", display: "flex", justifyContent: "end", zIndex: "1000" }}>
        <Box width={"169px"} height={"39px"} borderRadius={"2px 7px"} backgroundColor={theme.colors.primary[0]}
          marginRight={["1rem", "3.5rem", "0", "0"]} color={theme.colors.white}
          display={["flex", "flex", "none", "none"]}
          justifyContent={"center"} alignItems={"center"}
          bottom={"1rem"} left={"1rem"} position={"sticky"}
          style={{ fontFamily: "sans-serif" }} tabIndex={0}><a href="https://onelink.to/g78u9z" style={{ textDecoration: 'none' }}><div style={{ fontFamily: "sans-serif", color: theme.colors.white }}>Darme de alta</div></a>
        </Box>
      </Box>

      <Box width={'100%'} height={'auto'} flex={'flex'} justifyContent={'space-between'} flexDirection={['column', 'column', 'row', 'row']} tabIndex={0}>
        {cardsData.map(({ title, text1, text2, key }) => (
          <Cards title={title} text1={text1} text2={text2} key={key} />
        ))}

      </Box>

      <Box width={'100%'} flex={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} marginTop={["0", "0", "1rem", "1rem"]}>
        <VStack
          width={['100%', '100%', '50%', '50%']}
          height={'auto'}
          backgroundColor={theme.colors.white}
          borderRadius={'3px 20px'}
          paddingX={['7%', '7%', '2%', '2%']}
          marginBottom={['2rem', '2rem', '0', '0']}
        >
          <Text color={theme.colors.secondary[1]} fontSize={'22px'} lineHeight={'27px'} style={{ height: '40px' }} tabIndex={0}>
            {' '}
            Más vendés, más sumás.
          </Text>
          <Box
            color={theme.colors.secondary[1]}
            marginBottom={'2rem'}
            height={['2rem', '2rem', '4.5rem', '4.5rem']}
            style={{ fontSize: '16px', lineHeight: '21px' }}
            tabIndex={0}
          >
            {' '}
            Sumás puntos Mesumo con cada venta.
          </Box>
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            color={theme.colors.secondary[1]}
            height={['3rem', '3rem', '4rem', '4rem']}
            onClick={() => setClick(!click)}
            style={{ fontSize: '20px', lineHeight: '21px', fontStyle: 'bold' }}
            tabIndex={0}
          >
            ¿Cómo funciona?<IconArrow />
          </Box>
          <SolapaMovil click={click}>

            <Text fontSize={'16px'} style={{ width: "auto" }} tabIndex={0}>
              Cada vez que hagas un cobro acreditás un punto por cada $2.400, con un tope de 1.000 puntos por mes.
            </Text>
            <Text fontSize={'16px'} tabIndex={0}>
              Recordá que si además tenés tu paquete de productos Banco Provincia, por cada compra que hagas, sumás:
            </Text>
            <Box height={['3rem', '3rem', '2rem', '2rem']} display={['flex']} flexDirection={['row']} marginY={['0.5rem']}>
              <Box display={'flex'} justifyContent={'center'} width={'20px'} height={'100%'} marginRight={'1rem'} alignItems={'center'}>
                <img src={Simbolito} alt={''} />
              </Box>
              <Box style={{ fontSize: '16px', lineHeight: '21px' }} alignItems={'center'} tabIndex={0}>
                Visa o Mastercard Crédito: 1 punto por cada $/u$s 400.
              </Box>
            </Box>
            <Box height={['3rem', '3rem', '2rem', '2rem']} display={['flex']} flexDirection={['row']} marginY={['0.5rem']}>
              <Box display={'flex'} justifyContent={'center'} width={'20px'} height={'100%'} marginRight={'1rem'} alignItems={'center'}>
                <img src={Simbolito} alt={''} />
              </Box>
              <Box style={{ fontSize: '16px', lineHeight: '21px' }} alignItems={'center'} tabIndex={0}>
                Visa Débito: 1 punto por cada $/u$s 1.000.
              </Box>
            </Box>

            <Text fontSize={'16px'} tabIndex={0}>
              Si no tenés tu paquete de productos Banco Provincia, por cada compra que hagas, sumás:
            </Text>
            <Box height={['3rem', '3rem', '2rem', '2rem']} display={['flex']} flexDirection={['row']} marginY={['0.5rem']}>
              <Box display={'flex'} justifyContent={'center'} width={'20px'} height={'100%'} marginRight={'1rem'} alignItems={'center'}>
                <img src={Simbolito} alt={''} />
              </Box>
              <Box style={{ fontSize: '16px', lineHeight: '21px' }} alignItems={'center'} tabIndex={0}>
                Visa o Mastercard Crédito: 1 punto por cada $/u$s 800.
              </Box>
            </Box>
            <Box height={['3rem', '3rem', '2rem', '2rem']} display={['flex']} flexDirection={['row']} marginY={['0.5rem']}>
              <Box display={'flex'} justifyContent={'center'} width={'20px'} height={'100%'} marginRight={'1rem'} alignItems={'center'}>
                <img src={Simbolito} alt={''} />
              </Box>
              <Box style={{ fontSize: '16px', lineHeight: '21px' }} alignItems={'center'} tabIndex={0}>
                Visa Débito: 1 punto por cada $/u$s 2.000.
              </Box>
            </Box>

            <Text fontSize={'16px'} tabIndex={0}>
              Podés conocer los puntos acumulados y canjearlos ingresando al portal Mesumo.
            </Text>
            <Button backgroundColor={theme.colors.secondary[1]} color={theme.colors.white} style={{ width: '50%', border: 'none', borderRadius: '2px 7px', padding: '1.5%' }}><a href={"https://mesumo.bancoprovincia.com.ar/"} target='_blank' style={{ textDecoration: "none", color: theme.colors.white }} tabIndex={0}>Ir la portal</a></Button>
            <Text fontSize={'16px'}>
              <a href={"https://www.bancoprovincia.com.ar/CDN/Get/bases_y_condiciones_mesumo"} target='_blank' style={{ textDecoration: "none", color: theme.colors.secondary[1] }} tabIndex={0}> Bases y condiciones.</a>

            </Text>
          </SolapaMovil>
        </VStack>

      </Box>

      <VideoCDNIComercios />

      <Box width={"100%"} minHeight={["30rem", "30rem", "20rem", "20rem"]} backgroundColor={"rgb(39,157,46, 0.2)"} justifyContent={["flex-end", "flex-end", "inherit", "inherit"]} borderRadius={'3px 20px'} marginTop={["1rem", "1rem", "5rem", "5rem"]} flexDirection={["column-reverse", "column-reverse", "row", "row"]} marginBottom={["3rem", "5rem", "0", "0"]}>
        <Box width={["100%", "100%", "50%", "40%"]} justifyContent={["end", "end", "center", "center"]} paddingRight={["10%", "10%", "0", "0"]}>
          <Box width={["30%", "30%", "18rem", "18rem"]} height={"auto"} position={"absolute"} top={["-77px", "-77px", "-50px", "-50px"]} borderRadius={'3px 20px'}>
            <img width={"100%"} height={"100%"} style={{ borderRadius: '3px 20px', backgroundPosition: "center", backgroundAttachment: "contain", backgroundSize: "cover" }} src='/CDN/Get/imagen_roles_cdni_comercios' />
          </Box>
        </Box>
        <Box width={["100%", "100%", "50%", "60%"]} display={"flex"} flexDirection={"column"}>
          <Box width={"100%"} height={"2rem"} display={"flex"} justifyContent={"end"}>
            <Box style={{ fontSize: "16px" }} width={"125px"} height={"41px"} backgroundColor={theme.colors.white} alignItems={"center"} paddingLeft={"1rem"} borderTopRightRadius={'20px'} borderBottomLeftRadius={"7px"} >Nueva funcionalidad!</Box>
          </Box>
          <Box flexDirection={"column"} paddingLeft={["2rem", "2rem", "0", "0"]} paddingRight={["2rem", "2rem", "4rem", "4rem"]} paddingBottom={"2rem"} >
            <Text
              fontSize={"26px"}
              color={theme.colors.primary[0]}
              lineHeight={['33px', '33px', '43px', '43px']}
              textAlign={"start"}
              margin={0}
              marginTop={["1rem", "1rem", "1rem", "0"]}
              tabIndex={0}

            >
              Alta de Puntos de Venta
            </Text>
            <br />
            <Text fontSize={'16px'} lineHeight={'21px'} marginY={"0"} tabIndex={0}>
              Desde la opción Administrar – Puntos de venta, ahora podés dar de alta hasta 5 puntos de venta y asociarlos a cualquiera de las cuentas que tengas disponible para Cuenta DNI. De esta forma, vas a poder cobrar y ver los movimientos de cada local por separado.
            </Text>

            <Text fontSize={'16px'}>
              {width > 768 ?
                <a href="/cuentadni/contenidos/cdniComerciosFaq" target='_blank' style={{ color: theme.colors.primary[0] }}> Conocé más acá.</a> :
                <a href="/cuentadni/contenidos/cdniComerciosFaq" target='_blank' style={{ color: theme.colors.primary[0] }}> Conocé más acá.</a>
              }
            </Text>
            <Text
              fontSize={"26px"}
              color={theme.colors.primary[0]}
              lineHeight={['33px', '33px', '43px', '43px']}
              textAlign={"start"}
              margin={0}
              marginTop={["1rem", "1rem", "1rem", "0"]}
              tabIndex={0}

            >
              Alta de personas usuarias
            </Text>
            <br />
            <Text fontSize={'16px'} lineHeight={'21px'} marginY={"0"} tabIndex={0}>
              Desde la opción Administrar-Usuarios, también podés dar de alta nuevas personas usuarias, para que tu equipo también pueda cobrar desde su celular.
              Hay 3 roles con diferentes permisos, según la responsabilidad de cada colaborador/a. Encargado/a Full, Encargado/a y Vendedor/a.
            </Text>

            <Text fontSize={'16px'}>
              {width > 768 ?
                <a href="/cuentadni/contenidos/cdniComerciosFaq" target='_blank' style={{ color: theme.colors.primary[0] }}> Conocé más acá.</a> :
                <a href="/cuentadni/contenidos/cdniComerciosFaq" target='_blank' style={{ color: theme.colors.primary[0] }}> Conocé más acá.</a>
              }
            </Text>
          </Box>
        </Box>
      </Box>

      <Box width={'100%'} flex={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
        <Box
          width={'44%'}
          height={'5px'}
          marginY={'4rem'}
          border={'none'}
          borderRadius={'2rem'}
          backgroundImage={'linear-gradient(to right, #279d2e, #00a563, #00aec3)'}
        />

        <Text fontSize={['22px', '22px', '28px', '28px']} lineHeight={['27px', '27px', '37px', '37px']} tabIndex={0}>
          ¿Cómo adherirte?
        </Text>
        <Text
          fontSize={['16px', '16px', '22px', '22px']}
          lineHeight={['21px', '21px', '21px', '27px']}
          textAlign={'center'}
          style={{ width: '40%' }}
          tabIndex={0}
        >
          Seguí estos pasos y activá la app:
        </Text>

        <Box
          width={'60%'}
          height={'auto'}
          display={'flex'}
          flexDirection={['column', 'column', 'row', 'row']}
          alignItems={['center', 'justify']}
        >
          <Separador time={'1.3s'}>
            <Box height={'4rem'} display={'flex'} justifyContent={'center'}>
              <img width={'30%'} src={'/CDN/Get/CDNI_Form_Descarga'} alt={"Descargá la app en tu celular"} />
            </Box>
            <Box height={'3rem'} display={'flex'} justifyContent={'center'} tabIndex={0}>
              Descargá la app en tu celular
            </Box>
          </Separador>
          <Separador time={'0.5s 1s'}>
            <Box height={'5rem'} display={'flex'} justifyContent={['center', 'center', 'end', 'end']}>
              <IconLinea src={'/CDN/Get/CDNI_Form_Linea_H'} />
            </Box>
          </Separador>
          <Separador time={'0.5s 2s'}>
            <Box height={'4rem'} display={'flex'} justifyContent={'center'}>
              <img width={'30%'} src={'/CDN/Get/CDNI_Form_User'} alt={"Validá tu identidad"} />
            </Box>
            <Box height={'3rem'} display={'flex'} justifyContent={'center'} tabIndex={0}>
              Validá tu identidad
            </Box>
          </Separador>
          <Separador time={'0.5s 3s'}>
            <Box height={'5rem'} display={'flex'} justifyContent={['center', 'center', 'end', 'end']}>
              <IconLinea src={'/CDN/Get/CDNI_Form_Linea_H'} />
            </Box>
          </Separador>
          <Separador time={'0.5s 4s'}>
            <Box height={'4rem'} display={'flex'} justifyContent={'center'}>
              <img width={'30%'} src={'/CDN/Get/CDNI_Form_Diario'} alt={"Completá los datos"} />
            </Box>
            <Box height={'3rem'} display={'flex'} justifyContent={'center'} tabIndex={0}>
              Completá los datos
            </Box>
          </Separador>
          <Separador time={'0.5s 5s'}>
            <Box height={'5rem'} display={'flex'} justifyContent={['center', 'center', 'end', 'end']}>
              <IconLinea src={'/CDN/Get/CDNI_Form_Linea_H'} />
            </Box>
          </Separador>
          <Separador time={'0.5s 6s'} style={{ color: '#279C2E' }}>
            <Box height={'4rem'} display={'flex'} justifyContent={'center'}>
              <img width={'30%'} src={'/CDN/Get/CDNI_Form_Check'} alt={"¡Estas listo para cobrar!"} />
            </Box>
            <Box height={'3rem'} display={'flex'} justifyContent={'center'} tabIndex={0}>
              {' '}
              ¡Estás listo para cobrar!
            </Box>
          </Separador>
        </Box>

        <Box
          width={'100%'}
          height={'auto'}
          display={'flex'}
          marginTop={"40px"}
          flexDirection={['column', 'column', 'row', 'row']}
        >
          <Box width={['100%', '100%', '50%', '50%']} flexDirection={"column"}>
            <Text
              fontSize={"26px"}
              color={theme.colors.secondary[1]}
              lineHeight={['33px', '33px', '33px', '33px']}
              margin={0}
              marginTop={["40px", "40px", "40px", "40px"]}
              tabIndex={0}
              fontWeight={"bold"}
              textAlign={["center", "center", "start", "start"]}
            >
              Conocé cómo ser parte de
              Cuenta DNI Comercios
            </Text>
            <Text fontSize={'20px'} lineHeight={["31px", "31px", "28px", "28px"]} tabIndex={0} textAlign={["center", "center", "start", "start"]}>
              Mirá el paso a paso y empezá a cobrar.            </Text>

          </Box>



          <Box width={['100%', '100%', '50%', '50%']} height={"100%"} alignItems={'center'} justifyContent={["center", "center", "start", "start"]}>
            <Box width={['100%', '100%', '100%', '100%']} height={["400px", "400px", "28rem", "28rem"]} borderRadius={'3px 12px'}>
              <div style={{ paddingBottom: '56.25%' }} >
                <iframe
                  title="video-modal"
                  style={{ position: 'absolute', borderRadius: "1px 10px" }}
                  width="100%"
                  height="100%"
                  src={Urls.getYoutubeEmbedUrl('3XMNKSU623M?feature=share')}
                  allow="autoplay"
                  allowFullScreen={true}

                />
              </div>
            </Box>
          </Box>

        </Box>



        {width > 768 ? (
          <Box
            width={'65%'}
            height={'auto'}
            backgroundColor={theme.colors.secondary[2]}
            borderRadius={'3px 20px'}
            marginTop={'4rem'}
            padding={'2% 5%'}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'center'}
            id="CDNI_QR"
            tabIndex={0}
          >
            <Text fontSize={'28px'} lineHeight={'37px'} color={theme.colors.primary[0]} textAlign={'center'} style={{ marginBottom: '0' }} tabIndex={0}>
              Escaneá el QR y descargá la app<br />
              para darte de alta.
            </Text>

            <Box width={'156px'} height={'156px'} marginBottom={'1rem'} >
              <img src="/CDN/Get/CDNI_QR" alt='imagen QR'/>
            </Box>
            <Text fontSize={'28px'} lineHeight={'37px'} color={theme.colors.primary[0]} textAlign={'center'} tabIndex={0}>
              ¡Somos más de  10 millones de usuarios/as y más de 189 mil comercios!
              <br/>
              Sumate a nuestra comunidad vos también.
            </Text>
          </Box>

        ) : (
          <Text
            fontSize={'16px'}
            lineHeight={'22px'}
            color={theme.colors.secondary[1]}
            textAlign={'center'}
            style={{ marginBottom: '0', marginTop: "3rem" }}
            fontWeight={'bolder'}
            tabIndex={0}
          >
            ¡Somos más de  10 millones de usuarios/as y más de 189 mil comercios!
            <br/>
            Sumate a nuestra comunidad vos también.
          </Text>
        )}

          <Box width={"70%"} height={["auto", "auto", "10rem", "10rem"]} display={"flex"} flexDirection={["column", "column", "row", "row"]} justifyContent={"center"} alignItems={"center"} marginY={"2rem"}>
          <Box width={["50%", "50%", "40%", "40%"]} height={["6rem", "6rem", "100%", "100%"]} alignItems={"center"} justifyContent={["center", "center", "flex-end", "flex-end"]} paddingRight={["0", "0", "2rem", "2rem"]}>
            <Box style={{ backgroundColor: theme.colors.primary[0], borderRadius: "50%", textAlign: "center", width: "80px", height: "80px", padding: "15px", color: theme.colors.white }}><img src={contacto} /></Box>
          </Box>
          <Box width={["50%", "50%", "60%", "60%"]} height={["10rem", "10rem", "100%", "100%"]} alignItems={"center"}> <Text fontSize={"18px"} tabIndex={0}> Contactanos en nuestra línea exclusiva: <br /><br /> <a href='tel:08106662364' style={{ textDecoration: "none", color: theme.colors.secondary[1], fontWeight: "bold" }}>0810 666 2364</a></Text></Box>

        </Box>

        <Box
          width={['80%', '80%', '60%', '60%']}
          display={'flex'}
          justifyContent={'space-between'}
          marginTop={'2rem'}
          style={{ color: theme.colors.primary[0], fontSize: '20px', lineHeight: '25px' }}
          onClick={() => setVer(!ver)}
          aria-label={"menú desplegable con información legal"}
          tabIndex={0}
        >
          <Text><sup>(*)(**)</sup>Información legal <IconArrow /></Text>
        </Box>
        {ver ? (
          <Box
            width={['80%', '80%', '60%', '60%']}
            height={'auto'}
            marginBottom={'2rem'}
            display={'flex'}
            flexDirection={'column'}
            style={{ fontSize: '16px', lineHeight: '20px' }}
            tabIndex={0}
          >
            <Text tabIndex={0}><sup>(*)</sup> <b>CUENTA DNI COMERCIOS: </b>LAS TRANSFERENCIAS SERÁN GRATUITAS PARA “EL/LA CLIENTE/A” DURANTE LOS PRIMEROS TRES MESES CALENDARIO COMPLETOS DESDE EL COMIENZO DE SU OPERATORIA O HASTA ALCANZAR EL EQUIVALENTE A 1000 UVAS, DE ACUERDO A LO ESTIPULADO EN EL TEXTO ORDENADO DEL “BCRA” – SEGÚN COMUNICACIÓN A 7175 Y SUS MODIFICATORIAS– “SISTEMA NACIONAL DE PAGOS – TRANSFERENCIAS – NORMAS COMPLEMENTARIAS”. DURANTE ESTE PERÍODO NO SERÁ APLICABLE EL PRECIO A PAGAR POR EL COMERCIO AL ACEPTADOR, EN ADELANTE “COMISIÓN” NI SE PODRÁN APLICAR LOS COSTOS DE PROCESAMIENTO POR LA TRANSACCIÓN. ASIMISMO, SE INFORMA QUE UNA VEZ FINALIZADO EL TRAMO GRATUITO, LA COMISIÓN A PAGAR POR EL COMERCIO ES DEL 0,6% SOBRE EL MONTO DE LA TRANSACCIÓN CURSADA POR PAGO CON TRANSFERENCIA DE ACUERDO CON LA SECCIÓN 3. –EL PRECIO FINAL DE LA COMPRA–, SEGÚN LO ESTABLECIDO EN EL TEXTO ORDENADO DEL “BCRA” – SEGÚN COMUNICACIÓN A 7175 Y SUS MODIFICATORIAS – “SISTEMA NACIONAL DE PAGOS – TRANSFERENCIAS – NORMAS COMPLEMENTARIAS.
              <a href="http://www.bcra.gov.ar/pdfs/comytexord/A7175.pdf" target="_blanc" style={{ marginLeft: "10px" }}>
                WWW.BCRA.GOV.AR/PDFS/COMYTEXORD/A7175.PDF</a></Text>
            <Text tabIndex={0}><sup>(**)</sup>Sujeto a condiciones prestablecidas.</Text>
          </Box>
        ) : (
          <></>
        )}
        <Box width={['80%', '80%', '60%', '60%']} height={'0.5px'} backgroundColor={theme.colors.secondary[1]} marginBottom={'5rem'} />
      </Box>

    </>

  );
};

type Props = {
  title: React.ReactElement;
  text1: React.ReactElement;
  text2: React.ReactElement;
};

const Cards: React.FC<Props> = ({ title, text1, text2 }) => {

  return (
    <VStack
      width={['100%', '100%', '24%', '24%']}
      height={'100%'}
      backgroundColor={theme.colors.white}
      borderRadius={'3px 20px'}
      paddingX={['7%', '7%', '2%', '2%']}
      marginBottom={["1rem", "1rem", "0.5rem", "0.5rem"]}
    >
      <Box height={["auto", "auto", "7rem", "5rem"]} marginBottom={"1rem"} tabIndex={0}>
        <Text fontWeight={"100"} color={theme.colors.secondary[1]} fontSize={'22px'} lineHeight={"22px"}>
          {title}
        </Text>
      </Box>

      <Box
        color={theme.colors.secondary[1]}
        marginBottom={'1rem'}
        height={["auto", "auto", "5rem", "4rem"]}
        style={{ fontSize: '16px', lineHeight: '21px' }}
        tabIndex={0}
      >
        {text1}
      </Box>
      <Box
        color={theme.colors.secondary[1]}
        marginBottom={"1rem"}
        paddingBottom={["1rem", "1rem", "0", "0"]}
        style={{ fontSize: '16px', lineHeight: '21px' }}
        tabIndex={0}
      >
        {text2}
      </Box>
    </VStack>
  );
};